<template>
  <v-alert
    id="wizard-alert"
    :value="showAlert"
    color="softInfo"
    icon="mdi-information"
    :class="alertClass"
    transition="scale-transition"
  >
    <div class="wizard-alert-text">
      <slot name="text"></slot>
    </div>

    <div class="wizard-alert-ok">
      <v-btn small class="elevation-0" color="primary" @click="okWizard">
        <span class="mr-1">{{ $t('views.common.wizardAlert.ok') }}</span>
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
import { get } from 'lodash'
import { mapState, mapActions } from 'vuex'
import { updateUser } from '@/lib/api.js'

export default {
  props: {
    section: {
      type: String,
      required: true,
    },
    alertClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['user']),
    showAlert() {
      return !get(this.user, `wizards.${this.section}`, null)
    },
  },
  methods: {
    ...mapActions({
      updateUsersInfo: 'UPDATE_USERS_INFO',
    }),
    async okWizard() {
      const wizards = get(this.user, 'wizards', {})
      wizards[this.section] = true
      await updateUser({
        uid: this.user.uid,
        data: {
          wizards,
        },
      })
      await this.updateUsersInfo()
    },
  },
}
</script>

<style lang="scss">
#wizard-alert {
  .wizard-alert-text {
    font-size: 15px;
  }
  .wizard-alert-ok {
    .v-btn__content {
      text-transform: capitalize;
    }
  }
}
</style>
